<template>
  <div id="app">
    <router-view v-if="isPlainLayout" />

    <el-container v-else class="site-shell">
      <el-header class="site-header" height="auto">
        <div class="header-inner">
          <div class="logo">
            <router-link to="/">
              <img src="./assets/img/toplogo.jpg" alt="中云图" />
            </router-link>
          </div>

          <button
            class="nav-toggle"
            type="button"
            :aria-expanded="menuOpen ? 'true' : 'false'"
            @click="menuOpen = !menuOpen"
          >
            <i :class="menuOpen ? 'el-icon-close' : 'el-icon-s-operation'"></i>
          </button>

          <el-menu
            :default-active="defaultActive"
            class="el-menu-demo site-menu"
            :class="{ 'is-open': menuOpen }"
            :mode="menuMode"
            :router="router"
            @select="handleSelect"
          >
            <el-menu-item index="/">首页</el-menu-item>
            <el-menu-item index="/news">新闻资讯</el-menu-item>
            <el-menu-item index="/product">产品中心</el-menu-item>
            <el-menu-item index="/case">经典案例</el-menu-item>
            <el-menu-item index="/goin">走进湖南中云图</el-menu-item>
            <el-menu-item index="/download">联系我们</el-menu-item>
          </el-menu>
        </div>
      </el-header>

      <el-main>
        <router-view />
      </el-main>

      <div class="footer" v-show="showFooter">
        <div class="footer-content">
          <div class="footer-main">
            <div class="footer-brand">
              <strong>湖南中云图地理信息科技有限公司</strong>
              <p>无人机航测 · 三维地理信息 · 行业解决方案</p>
            </div>
            <div class="footer-contact">
              <a href="tel:400-871-5117">400-871-5117</a>
              <span>zhuxingyuan010@vip.com</span>
              <span>长沙高新开发区芯城科技园8栋501</span>
            </div>
            <div class="footer-links">
              <router-link to="/goin">走进中云图</router-link>
              <router-link to="/news">新闻资讯</router-link>
              <router-link to="/case">经典案例</router-link>
              <router-link to="/download">联系我们</router-link>
            </div>
          </div>
          <div class="footer-qr">
            <img src="./assets/img/ercode.jpg" alt="微信二维码" />
            <span>关注微信</span>
          </div>
        </div>
        <div class="copyright">
          <span>© 湖南中云图地理信息科技有限公司</span>
        </div>
      </div>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      router: true,
      menuOpen: false,
      isMobile: false
    };
  },
  computed: {
    isPlainLayout() {
      const path = this.$route.path || "";
      return path.startsWith("/admin") || path === "/login";
    },
    defaultActive() {
      return this.$route.path || "/";
    },
    showFooter() {
      return this.$route.path !== "/";
    },
    menuMode() {
      return this.isMobile ? "vertical" : "horizontal";
    }
  },
  watch: {
    "$route.path"() {
      this.menuOpen = false;
    }
  },
  mounted() {
    this.updateViewport();
    window.addEventListener("resize", this.updateViewport);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateViewport);
  },
  methods: {
    handleSelect() {
      this.menuOpen = false;
    },
    updateViewport() {
      this.isMobile = window.innerWidth <= 960;
      if (!this.isMobile) this.menuOpen = false;
    }
  }
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
html,
body {
  height: 100%;
  overflow-x: hidden;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-height: 100%;
}

.site-header {
  padding: 0 !important;
  background: #fff;
  border-bottom: 1px solid #edf2f7;
  z-index: 100;
}

.header-inner {
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;
  min-height: 60px;
  padding: 0 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}

.logo {
  width: 220px;
  max-width: 52vw;
  padding: 8px 0;
  flex-shrink: 0;

  a {
    display: block;
  }

  img {
    width: 100%;
    display: block;
  }
}

.nav-toggle {
  display: none;
  width: 40px;
  height: 40px;
  border: 1px solid #d7e6f2;
  border-radius: 8px;
  background: #fff;
  color: #1f6fab;
  font-size: 20px;
  cursor: pointer;
}

.site-menu.el-menu {
  border-right: none;
  border-bottom: none;
  background: transparent;
}

.el-menu--horizontal > .el-menu-item {
  height: 60px;
  line-height: 60px;
  font-size: 15px;
  color: #35556d;
}

.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom-color: #1f6fab !important;
  color: #1f6fab !important;
}

.el-menu--horizontal > .el-menu-item:not(.is-disabled):hover {
  color: #1f6fab !important;
}

.el-main {
  padding: 0 !important;
}

.footer {
  width: 100%;
  overflow: hidden;
  background: linear-gradient(180deg, #125f93 0%, #0f4a73 100%);

  &-content {
    width: 1240px;
    max-width: calc(100% - 32px);
    margin: 0 auto;
    padding: 32px 0 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 28px;
  }
}

.footer-main {
  flex: 1;
  min-width: 0;
}

.footer-brand {
  strong {
    display: block;
    color: #fff;
    font-size: 18px;
    font-weight: 600;
  }

  p {
    margin: 8px 0 0;
    color: rgba(212, 237, 255, 0.85);
    font-size: 13px;
    letter-spacing: 1px;
  }
}

.footer-contact {
  margin-top: 16px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px 20px;

  a,
  span {
    color: rgba(255, 255, 255, 0.9);
    font-size: 13px;
    line-height: 1.6;
    text-decoration: none;
  }

  a:hover {
    color: #fff;
  }
}

.footer-links {
  margin-top: 18px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px 18px;

  a {
    color: #d4edff;
    text-decoration: none;
    font-size: 13px;
  }

  a:hover {
    color: #fff;
  }
}

.footer-qr {
  flex-shrink: 0;
  text-align: center;

  img {
    width: 96px;
    height: 96px;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.1);
    padding: 4px;
    display: block;
  }

  span {
    display: block;
    margin-top: 8px;
    color: rgba(212, 237, 255, 0.85);
    font-size: 12px;
  }
}

.footer .copyright {
  min-height: 36px;
  background: #0c3d5f;
  text-align: center;
  padding: 0 12px;

  span {
    color: rgba(255, 255, 255, 0.78);
    line-height: 36px;
    font-size: 12px;
  }
}

@media (max-width: 960px) {
  .nav-toggle {
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .site-menu.el-menu {
    display: none;
    position: absolute;
    top: calc(100% + 1px);
    left: 0;
    right: 0;
    z-index: 120;
    background: #fff;
    border-bottom: 1px solid #e6eef5;
    box-shadow: 0 12px 28px rgba(15, 47, 74, 0.12);
    padding: 8px 0;
  }

  .site-menu.el-menu.is-open {
    display: block;
  }

  .site-menu .el-menu-item {
    height: 46px;
    line-height: 46px;
    margin: 0 12px;
    border-radius: 8px;
  }

  .site-menu .el-menu-item.is-active {
    background: #eef6fb;
    color: #1f6fab !important;
  }

  .footer-content {
    flex-direction: column;
    align-items: flex-start;
    padding: 28px 0 22px;
  }

  .footer-qr {
    display: flex;
    align-items: center;
    gap: 12px;

    img {
      width: 72px;
      height: 72px;
    }

    span {
      margin-top: 0;
    }
  }
}

@media (max-width: 640px) {
  .logo {
    width: 170px;
  }

  .footer-brand strong {
    font-size: 16px;
  }

  .footer-contact {
    flex-direction: column;
    gap: 6px;
  }

  .footer-links {
    gap: 8px 14px;
  }
}
</style>
